import { render } from "./DistrictEditView.vue?vue&type=template&id=65dbedcd&scoped=true"
import script from "./DistrictEditView.vue?vue&type=script&lang=js"
export * from "./DistrictEditView.vue?vue&type=script&lang=js"

import "./DistrictEditView.vue?vue&type=style&index=0&id=65dbedcd&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65dbedcd"]])

export default __exports__